import axios from 'axios';
import fb from '@/firebaseConfig';

import {
  updateDoc,
  collection,
  query,
  where,
  getDoc,
  getDocs,
  arrayUnion,
  setDoc,
  doc,
  getFirestore
} from 'firebase/firestore';

import { getAuth, fetchSignInMethodsForEmail } from 'firebase/auth';

import { userModule } from './useAuth';

export const checkInvite = async ({ inviteId }) => {
  try {
    const db = getFirestore();
    const userRef = doc(collection(db, 'invites'), inviteId);
    const inviteDoc = await getDoc(userRef);
    console.log(inviteDoc);
    const invite = inviteDoc.data();
    invite.id = inviteDoc.id;
    console.log(invite);
    return invite;
  } catch (e) {
    throw new Error(e);
  }
};

export const getUserByEmail = async emails => {
  //  Search for users by email adress. Return an array[0] with profiles if user found and array[1] with ids if user not found.
  return new Promise((resolve, reject) => {
    const url = fb.paths.function + 'getUserFromEmail';
    axios
      .post(url, { emails })
      .then(result => {
        resolve(result.data);
      })
      .catch(e => {
        reject(e);
      });
  });
};

export const sendContextInvite = async ({ email, context }) => {
  console.log(`sending invite email to ${email} for access to ${context.id}`);
  let returnObject = {};
  const db = getFirestore();
  const q = query(collection(db, 'invites'), where('email', '==', email));
  try {
    const querySnapshot = await getDocs(q);
    console.log('does an invite already exist for this email?', querySnapshot);
    if (querySnapshot.size > 0) {
      querySnapshot.forEach(doc => {
        returnObject = doc.data();
        if (!returnObject.contexts.includes(context.id)) {
          const docRef = doc(db, 'invites', doc.id);
          const update = { contexts: arrayUnion(context.id) };
          updateDoc(docRef, update);
        }
      });
    } else {
      const newDocRef = doc(collection(db, 'invites'));
      console.log('newDocRef', newDocRef);
      returnObject = {
        id: newDocRef.id,
        avatar: 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y',
        email,
        name: email,
        pending: true,
        contexts: [context.id]
      };
      await setDoc(newDocRef, returnObject);
    }
    delete returnObject.contexts;
    console.log('returnObject', returnObject);

    //  Setup email
    const fromName = userModule.data.profile.name;
    const url = fb.paths.function + 'sendEmail';
    await axios.post(url, {
      templateId: 1838731,
      subject: `${fromName} has invited you to Collaborate on Context`,
      fromName,
      email,
      contextName: context.text
    });

    return returnObject;
  } catch (e) {
    console.log(e);
    throw new Error(e);
  }
};

export const sendInvite = async ({ email, inviteId }) => {
  const createdOn = new Date();
  //  Create invite in db
  try {
    let id;
    if (!inviteId) {
      // id = await dispatch('invites/addInviteDoc', { email, workspace }, { root: true });
      const db = getFirestore();
      const newDocRef = doc(collection(db, 'invites'));
      id = newDocRef.id;
      console.log('newDocRef', newDocRef);
      const returnObject = {
        id: newDocRef.id,
        avatar: 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y',
        email,
        name: email,
        pending: true,
        contexts: [],
        createdOn
      };
      await setDoc(newDocRef, returnObject);
    } else {
      id = inviteId;
    }

    //  Setup email
    const fromName = userModule.data.displayName;
    const url = fb.paths.function + 'sendEmail';
    axios
      .post(url, {
        templateId: 1352934,
        subject: `${fromName} has invited you to Context`,
        fromName,
        email,
        inviteId: id
      })
      .then(result => {
        return result.data;
      })
      .catch(e => {
        throw new Error(e);
      });
  } catch (e) {
    console.log(e);
    throw new Error(e);
  }
};

export const checkIfUser = async email => {
  let methods;
  let error;
  try {
    const auth = getAuth();
    methods = await fetchSignInMethodsForEmail(auth, email);
    console.log(methods);
  } catch (e) {
    methods = false;
    error = e;
  }
  return new Promise((resolve, reject) => {
    if (!methods) {
      reject(error);
    }
    const google = methods.includes('google.com');
    const password = methods.includes('password');
    resolve({ google, password });
  });
};
